const theme = {
  colors: {
    white: "#fff",
    black: "#000",
    bgColor: "#D4E0F1",
    cyan700: "#0e7490",
    cyan600: "#0891b2",
    cyan500: "#06b6d4",
    cyan400: "#c0e8ec",
    cyan300: "#ebf5fe",
    cyan200: "#cffafe",
    darkBlueText: "#267491",
    blackText: "#00092e",
    editorText: "#184f63",
    gray: "#c9c1c1",
    darkGray: "#8e8e9c",
    whitish: "#bdffff",
    red600: "#c31515",
    red500: "#f52a2a",
    green600: "#00cd99",
    green700: "#04b084",
    policeBlue: "#1b5266",
    darkSkyBlue: "#89c5cc",
    bubbles: "#ebfbfc",
    crystal: "#add5d9",
    azureishWhite: "#dae6f0",
  },
  fontSizes: {
    xxxl: 28,
    xxl: 22,
    xl: 20,
    lg: 18,
    md: 16,
    sm: 14,
    xs: 12,
    xxs: 10,
  },
  fonts: {
    bold: "Montserrat-Bold",
    semibold: "Montserrat-Semibold",
    medium: "Montserrat-Medium",
    regular: "Montserrat-Regular",
    light: "Montserrat-Light",
  },
} ;

export default theme;
